export default __webpack_public_path__ + "static/last_webcast-9703e03e5eedacadd6dc738a02d0a817.svg";